// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamentoFranquia_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/formas_pagamento_franquias/lista
 *
 * As formas de pagamento como esta franquia as aplica (chamado 2026-0023).
 */
import { registerContract } from './validate'

export interface FormasPagamentoFranquia_ListaInput {
franquia_id: number
}

registerContract('FormasPagamentoFranquia_ListaInput', {
  franquia_id: { type: 'number',  required: true },
})
